import React, { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { defaultSettingsTopProducts } from '../../components/ProductSelectionsContainer/ProductSelection/ProductsInCarousel/utils'
import { useAnalytics } from '../../contexts/AnalyticsContext'
import AnalyticsConstants from '../../contexts/AnalyticsContext/constants.json'
import useOnScreen from '../Advertising/useOnScreen'

const ProductsInCarouselAnalytics = ({
  className = '',
  children,
  index,
  origin,
  products,
  settings = defaultSettingsTopProducts,
  tab,
}) => {
  const [elementsPerPage, setElementsPerPage] = useState(0)
  const [currentCarouselIndex, setCurrentCarouselIndex] = useState(0)
  const { getDataForGoogleAnalytics } = useAnalytics()
  const reference = useRef()
  const isVisible = useOnScreen(reference)
  const randomID = (Math.random() + 1).toString(36).substring(7)
  const containerClassName = `${className}_${randomID}`
  const { EVENTS, FLOW_TYPES } = AnalyticsConstants

  useEffect(() => {
    if (isVisible && elementsPerPage !== 0 && currentCarouselIndex < products.length) {
      getDataForGoogleAnalytics({
        eventName: EVENTS.ITEM_LIST_VIEW,
        flowType: FLOW_TYPES.HOME,
        data: {
          origin: `${origin}`,
          section: index,
          sectionName: tab.toLowerCase().split(' ').join('_'),
          page: currentCarouselIndex / elementsPerPage + 1,
          nbHits: products.length,
          nbPages: Math.ceil(products.length / elementsPerPage),
          products: products.slice(currentCarouselIndex, elementsPerPage + currentCarouselIndex),
        },
      })
    }
  }, [elementsPerPage, currentCarouselIndex, isVisible])

  const onMappedRef = useCallback((node) => {
    if (!node) return
    const computedElemsLength = window.document
      .querySelector(`.${containerClassName}`)
      ?.querySelectorAll('div.slick-active').length
    setElementsPerPage((prevState) => prevState + computedElemsLength)
  }, [])

  const afterChange = (index) => {
    setCurrentCarouselIndex(index)
  }

  return (
    <div className="m-auto" ref={reference}>
      {React.cloneElement(children, {
        origin,
        promotionProducts: products,
        customSettingsTopProducts: {
          ...settings,
          afterChange,
          ref: onMappedRef,
          className: containerClassName,
        },
      })}
    </div>
  )
}

ProductsInCarouselAnalytics.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  index: PropTypes.number,
  origin: PropTypes.string.isRequired,
  products: PropTypes.array.isRequired,
  settings: PropTypes.object.isRequired,
  tab: PropTypes.string.isRequired,
}

ProductsInCarouselAnalytics.defaultProps = {
  className: '',
  index: 0,
  tab: 'tab',
}

export default ProductsInCarouselAnalytics
